import { usePage } from '@inertiajs/react';

interface PageProps {
    auth: {
        user: {
          id: string;
          email: string;
          name: string;
        } | null;
        renter: {
          id: string;
          email: string;
          name: string;
        } | null;
        roommate: {
          id: string;
          email: string;
          name: string;
          household_id: string;
        } | null;
        authenticated: boolean;
      };

      [key: string]: any; //index signature
}

export function useAuth() {
  const { auth } = usePage<PageProps>().props;

  return {
    user: auth.user,
    renter: auth.renter,
    roommate: auth.roommate,
    isAuthenticated: auth.authenticated
  };
}
